import LandscapeMode from '~/images/landscape-mode.svg';
import { respondUntil, TABLET } from '~/utils/breakpoints';
import React, { Component } from 'react';

import Modal from './modal';
import Gallery from './photo_gallery/gallery';
import PhotoGalleryButton from './photo_gallery/photo_gallery_button.jsx';

export default class PhotoGalleryModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
    };
  }

  render() {
    return (
      <Modal
        open={this.state.isOpenModal}
        buttonClassName={this.props.className}
        className="modal--photo-gallery"
        button={<PhotoGalleryButton />}
        shouldCloseOnOverlayClick={true}
        onOpen={this.onModalOpen}
        onClose={this.onModalClose}
        gaCategory="gallery-modal"
      >
        <Gallery slides={this.props.slides} />
        <img src={LandscapeMode} className="photo-gallery__landscape-mode-icon" />
      </Modal>
    );
  }

  componentDidMount() {
    window.headerImageClicked = () => {
      this.setState({ isOpenModal: true });
    };
  }

  onModalOpen = () => {
    if (typeof zE !== 'undefined' && respondUntil(TABLET)) {
      zE('webWidget', 'hide');
    }

    if (!this.state.isOpenModal) {
      this.setState({ isOpenModal: true });
    }
  };

  onModalClose = () => {
    if (typeof zE !== 'undefined' && respondUntil(TABLET)) {
      zE('webWidget', 'show');
    }

    if (this.state.isOpenModal) {
      this.setState({ isOpenModal: false });
    }
  };
}
